import { signOutWithOkta } from '@eneco/auth';
import Cookies from 'js-cookie';

import { clearAllSelectedDeliveryAddressIds } from '../selectedDeliveryAddress';
import { KEY_ACCOUNTS, KEY_IMPERSONATION, KEY_SELECTED_ACCOUNT } from './constants';

const impersonationUri = '/my-eneco/impersonation';

type UserType = 'champion' | undefined;

/** Clears app-local session state (cookies, cached selections). Registered with
 * @eneco/auth so it also runs on automatic MyZone session expiry. */
export const clearLocalSession = () => {
  Cookies.remove(KEY_ACCOUNTS);
  Cookies.remove(KEY_IMPERSONATION);
  Cookies.remove(KEY_SELECTED_ACCOUNT);
  clearAllSelectedDeliveryAddressIds();
};

export default async function logout(userType: UserType = undefined, redirectUri?: string) {
  // remove impersonation context but do not fully log out the user
  if (userType === 'champion') {
    clearLocalSession();
    window.location.href = impersonationUri;
    return;
  }

  await signOutWithOkta(redirectUri ? { redirectUri } : undefined);
}
